/*
 *
 * FulfillmentNoteDetailPage reducer
 *
 */

import { ContainerActions, ContainerState } from './types';

import ActionTypes from './constants';

export const initialState: ContainerState = {
  fulfillmentNote: {},
  loading: false,
  isOpen: false,
  selectedNote: {},
};

function fulfillmentNoteDetailPageReducer(state: ContainerState = initialState, action: ContainerActions) {
  const { type, payload } = action as any;
  switch (type) {
    case ActionTypes.FETCH_FULFILLMENT_NOTE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ActionTypes.FETCH_FULFILLMENT_NOTE_SUCCESS:
      return {
        ...state,
        fulfillmentNote: {
          ...state.fulfillmentNote,
          ...payload,
        },
        loading: false,
      };
    case ActionTypes.FETCH_FULFILLMENT_NOTE_FAILURE:
      return {
        ...state,
        fulfillmentNote: {
          ...state.fulfillmentNote,
        },
        loading: false,
      };
    case ActionTypes.RATING_MODAL_OPEN:
      return {
        ...state,
        isOpen: true,
        selectedNote: payload,
      };
    case ActionTypes.RATING_MODAL_CLOSE:
      return {
        ...state,
        isOpen: false,
        selectedNote: {},
      };
    case ActionTypes.RATE_SUCCESS:
      return {
        ...state,
        isOpen: false,
        selectedNote: {},
        fulfillmentNote: {
          ...state.fulfillmentNote,
          feedback: { ...payload.feedback },
        },
      };
    case ActionTypes.RATE_FAILURE:
      return {
        ...state,
        isOpen: false,
        selectedNote: {},
      };
    default:
      return state;
  }
}

export default fulfillmentNoteDetailPageReducer;
